var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-slider',{attrs:{"label":_vm.label,"thumb-label":"always","max":_vm.max,"min":0},on:{"input":_vm.onInput},scopedSlots:_vm._u([{key:"thumb-label",fn:function(ref){
var value = ref.value;
return [_c('v-chip',{staticClass:"mb-2",attrs:{"color":"primary","dark":""}},[_vm._v(_vm._s(_vm._f("prettyTime")(value)))])]}}]),model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})}
var staticRenderFns = []

export { render, staticRenderFns }